import { defineCatalogue } from '../../../i18n';

export const dataSharedCatalogue = defineCatalogue(
  {
    'dimension.label': 'Dimensão',
    'dimension.placeholder': 'Escolher dimensão',
    'metric.label': 'Métrica',
    'metric.views': 'Visualizações',
    'metric.comments': 'Comentários',
    'groups.empty': 'Sem categorias ativas para agrupar',
    'groups.accounts.one': '{n} conta',
    'groups.accounts.other': '{n} contas',
    'postMenu.open': 'Ações da publicação',
    'postMenu.details': 'Abrir publicação',
    'postMenu.source': 'Ver no {network}',
    'postMenu.markUnrelated': 'Marcar como não relacionada',
    'postMenu.markRelated': 'Marcar como relacionada',
    'window.label': 'Janela',
  },
  {
    'dimension.label': 'Dimension',
    'dimension.placeholder': 'Choose a dimension',
    'metric.label': 'Metric',
    'metric.views': 'Views',
    'metric.comments': 'Comments',
    'groups.empty': 'No active categories to group by',
    'groups.accounts.one': '{n} account',
    'groups.accounts.other': '{n} accounts',
    'postMenu.open': 'Post actions',
    'postMenu.details': 'Open post',
    'postMenu.source': 'View on {network}',
    'postMenu.markUnrelated': 'Mark as not related',
    'postMenu.markRelated': 'Mark as related',
    'window.label': 'Window',
  },
);

export const ds = dataSharedCatalogue.t;
export const dsPlural = dataSharedCatalogue.plural;
